import { __assign } from "tslib";
import _ from 'lodash';
function createDefaultVariationsChoices(item, itemsHash, depth) {
    if (!item.variations) {
        return [];
    }
    return item.variations.map(function (variation) {
        if (variation.defaults) {
            return variation.defaults.map(function (itemId) {
                var _a;
                return createOrderItem({
                    itemId: itemId,
                    itemsHash: itemsHash,
                    price: ((_a = variation.prices) === null || _a === void 0 ? void 0 : _a[itemId]) || 0,
                    depth: depth + 1,
                });
            });
        }
        else {
            return [];
        }
    });
}
export function createOrderItem(_a) {
    var _b;
    var itemId = _a.itemId, itemsHash = _a.itemsHash, price = _a.price, _c = _a.depth, depth = _c === void 0 ? 0 : _c;
    var item = itemsHash[itemId];
    var result = {
        itemId: item.id,
        count: 1,
        price: (_b = price !== null && price !== void 0 ? price : item.price) !== null && _b !== void 0 ? _b : 0,
    };
    if (item.variations && depth <= 4) {
        result.variations = item.variations;
        result.variationsChoices = createDefaultVariationsChoices(item, itemsHash, depth);
    }
    if (!_.isNil(item.hideSpecialRequest)) {
        result.hideSpecialRequest = item.hideSpecialRequest;
    }
    return result;
}
function generateUniqueItemId() {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
}
export function createUniqueOrderItem(args) {
    var result = __assign({ uniqueItemId: generateUniqueItemId() }, createOrderItem(args));
    return result;
}
export function getOrderItemFromUniqueOrderItem(item) {
    var result = __assign({}, item);
    delete result.uniqueItemId;
    return result;
}
function traverseOrderItem(orderItem, variationPath) {
    var _a, _b, _c, _d;
    var variationAnchor;
    var variationAnchorIndex;
    var orderItemAnchor = orderItem;
    if (variationPath[0].type === 'index') {
        // Setting up variation anchor. First item on variationPath must
        // be of type "index", otherwise, it means that the variationPath
        // is invalid, and we will throw an exception.
        variationAnchor = (_a = orderItem.variations) === null || _a === void 0 ? void 0 : _a[variationPath[0].value];
        variationAnchorIndex = variationPath[0].value;
    }
    if (typeof variationAnchor === 'undefined' ||
        typeof variationAnchorIndex === 'undefined') {
        // We will reach this point only in case of invalid variationPath.
        // In that case, we can not proceed, and as a last resort, we throw.
        throw new Error('Anchor not found');
    }
    // Let's start the traversal process. A variationPath is a list of objects,
    // that either point to a variation index (variations do not have ID's, thus
    // the order the only way to refer to a variation) or an itemId of a variation choice.
    var i = 1;
    var _loop_1 = function () {
        var variationPathItem = variationPath[i];
        if (variationPathItem.type === 'index') {
            variationAnchor = (_b = orderItemAnchor.variations) === null || _b === void 0 ? void 0 : _b[variationPathItem.value];
            variationAnchorIndex = variationPathItem.value;
        }
        else if (variationPath[i].type === 'itemId') {
            orderItemAnchor = (_c = orderItemAnchor.variationsChoices) === null || _c === void 0 ? void 0 : _c[variationAnchorIndex].find(function (_orderItem) {
                return _orderItem.itemId === variationPathItem.value;
            });
        }
        i++;
    };
    while (i < variationPath.length) {
        _loop_1();
    }
    if (typeof variationAnchor === 'undefined' ||
        typeof orderItemAnchor === 'undefined') {
        // As a final layer of type safety, we throw in case one of the values undefined
        throw new Error('Not found');
    }
    else {
        return {
            variation: variationAnchor,
            variationChoices: ((_d = orderItemAnchor === null || orderItemAnchor === void 0 ? void 0 : orderItemAnchor.variationsChoices) === null || _d === void 0 ? void 0 : _d[variationAnchorIndex]) || [],
        };
    }
}
function isRadioButton(variation) {
    return variation.minNumAllowed === 1 && variation.maxNumAllowed === 1;
}
export function toggleChoice(_a) {
    var _b;
    var orderItem = _a.orderItem, variationPath = _a.variationPath, choiceId = _a.choiceId, itemsHash = _a.itemsHash;
    var result = _.cloneDeep(orderItem);
    var _c = traverseOrderItem(result, variationPath), variation = _c.variation, variationChoices = _c.variationChoices;
    var choiceIndex = variationChoices.findIndex(function (oi) { return oi.itemId === choiceId; });
    var found = choiceIndex !== -1;
    if (isRadioButton(variation)) {
        // in case of radio button, clear selected choice
        variationChoices.pop();
    }
    else if (found) {
        // in case choice was found, remove it, and bail out
        variationChoices.splice(choiceIndex, 1);
        return result;
    }
    // in case choice was not found, add it, or replace existing one with it
    variationChoices.push(createOrderItem({
        itemId: choiceId,
        itemsHash: itemsHash,
        price: ((_b = variation.prices) === null || _b === void 0 ? void 0 : _b[choiceId]) || 0,
    }));
    return result;
}
export function calcOrderItemGrandTotal(orderItem) {
    var result = orderItem.price;
    if (orderItem.variationsChoices) {
        orderItem.variationsChoices.forEach(function (choices) {
            choices.forEach(function (choice) {
                result += calcOrderItemGrandTotal(choice);
            });
        });
    }
    return result * orderItem.count;
}
export function validateOrderItem(menu, orderItem) {
    var errors = [];
    var updatedOrderItem = _.cloneDeep(orderItem);
    var orderItemInMenu = menu.items.find(function (item) { return item.id === orderItem.itemId; });
    if (!orderItemInMenu) {
        throw new Error('Item was not found in menu');
    }
    if (orderItem.price !== orderItemInMenu.price) {
        errors.push({
            type: 'price_changed',
            itemId: orderItem.itemId,
        });
        updatedOrderItem.price = orderItemInMenu.price || 0;
    }
    var validated = validateVariations(menu, updatedOrderItem);
    errors.push.apply(errors, validated.errors);
    return {
        isValid: errors.length === 0,
        errors: errors,
        updatedOrderItem: validated.updatedOrderItem,
    };
}
function hasStaleVariations(orderItem, orderItemInMenu) {
    var _a, _b;
    var v1 = (_a = orderItem.variations) === null || _a === void 0 ? void 0 : _a.map(function (v) { return (__assign(__assign({}, v), { prices: null })); });
    var v2 = (_b = orderItemInMenu.variations) === null || _b === void 0 ? void 0 : _b.map(function (v) { return (__assign(__assign({}, v), { prices: null })); });
    return !_.isEqual(v1, v2);
}
function validateVariations(menu, orderItem) {
    var errors = [];
    var orderItemInMenu = menu.items.find(function (item) { return item.id === orderItem.itemId; });
    if (!orderItemInMenu) {
        throw new Error('Item was not found in menu');
    }
    if (hasStaleVariations(orderItem, orderItemInMenu)) {
        return {
            errors: [{ itemId: orderItem.itemId, type: 'stale-variations' }],
        };
    }
    if (orderItemInMenu.variations) {
        orderItem.variations = _.cloneDeep(orderItemInMenu.variations);
        if (orderItem.variationsChoices) {
            orderItem.variationsChoices.forEach(function (choices, variationIndex) {
                choices.forEach(function (choice) {
                    var _a, _b, _c;
                    var realVariationChoicePrice = ((_c = (_b = (_a = orderItem.variations) === null || _a === void 0 ? void 0 : _a[variationIndex]) === null || _b === void 0 ? void 0 : _b.prices) === null || _c === void 0 ? void 0 : _c[choice.itemId]) ||
                        0;
                    if (choice.price !== realVariationChoicePrice) {
                        errors.push({
                            type: 'variationChoice_price_changed',
                            itemId: orderItem.itemId,
                        });
                        choice.price = realVariationChoicePrice;
                    }
                    errors.push.apply(errors, validateVariations(menu, choice).errors);
                });
            });
        }
    }
    return { errors: errors, updatedOrderItem: orderItem };
}
export function isUniqueOrderItem(orderItem) {
    if (orderItem.uniqueItemId) {
        return true;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=orderItemLogic.js.map